// extracted by mini-css-extract-plugin
export var equalColumn = "_fp-0";